import { FC, PropsWithChildren, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from '../../i18n'

export type SideButtonProps = {
  to: string
  title?: string
  titleKey?: string
  testId?: string
  disabled?: boolean
} & PropsWithChildren

export const SideButton: FC<SideButtonProps> = ({ to, title, titleKey, testId, disabled = false, children }) => {
  const { t } = useTranslation('navigation')
  const location = useLocation()
  const [isHovered, setIsHovered] = useState<boolean>(false)

  // Use titleKey for translation if provided, otherwise use title directly
  const displayTitle = titleKey ? t(titleKey) : title || ''
  
  // Check if current route matches this button's route
  const isActive = location.pathname === to

  const onMouseOverEvent = () => {
    if (!disabled) {
      setIsHovered(true)
    }
  }

  const onMouseOutEvent = () => {
    setIsHovered(false)
  }

  const handleClick = (e: React.MouseEvent) => {
    if (disabled) {
      e.preventDefault()
      e.stopPropagation()
    }
  }

  const buttonContent = (
    <div
      className={`${disabled ? 'bg-gray-100 cursor-not-allowed opacity-50' : isActive ? 'bg-tdplprussian' : isHovered ? 'bg-tdplbisque' : 'bg-white'} rounded-xl my-[1rem]`}
    >
      <div className="grid grid-cols-3 gap-6 p-4 items-center justify-center align-middle">
        {children}
        <p
          className={`col-span-2 text-[1.25rem] font-bold whitespace-nowrap
            ${isActive ? 'text-white' : 'text-tdplindigo'}
          `}
        >
          {displayTitle}
        </p>
      </div>
    </div>
  )

  if (disabled) {
    return (
      <div onClick={handleClick} onMouseOver={onMouseOverEvent} onMouseOut={onMouseOutEvent} data-testid={testId}>
        {buttonContent}
      </div>
    )
  }

  return (
    <Link to={to} onMouseOver={onMouseOverEvent} onMouseOut={onMouseOutEvent} data-testid={testId}>
      {buttonContent}
    </Link>
  )
}
